import _ from 'lodash';

/**
 * Parses GET /sso/register-email-verify (NYL Expected Response: { data: { emailVerified, statusCode, status } }).
 */
export const parseRegisterEmailVerifyResponse = (response) => {
  const httpStatus = _.get(response, 'status', 0);

  if (httpStatus === 401) {
    return {
      unauthorized: true,
      emailVerified: false,
    };
  }

  if (httpStatus !== 200) {
    return {
      unauthorized: false,
      emailVerified: false,
      httpError: httpStatus,
    };
  }

  const nestedStatus = _.get(response, 'data.data.status', '');
  const nestedStatusCode = _.get(response, 'data.data.statusCode', false);
  if (nestedStatus === 'ERROR' && nestedStatusCode && nestedStatusCode !== 200) {
    return {
      unauthorized: false,
      emailVerified: false,
      httpError: nestedStatusCode,
    };
  }

  const emailVerifiedRaw = _.get(
    response,
    'data.data.emailVerified',
    _.get(response, 'data.emailVerified', false),
  );

  const emailVerified = emailVerifiedRaw === true || emailVerifiedRaw === 'true';

  const emailVerificationSentRaw = _.get(
    response,
    'data.data.emailVerificationSent',
    _.get(response, 'data.emailVerificationSent', undefined),
  );

  const result = {
    unauthorized: false,
    emailVerified,
  };

  if (emailVerificationSentRaw !== undefined) {
    result.emailVerificationSent = emailVerificationSentRaw === true
      || emailVerificationSentRaw === 'true';
  }

  return result;
};
